import { useState } from 'react';
import config from '../../utils/apiUrl';

const useCreateTransaction = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [transactionId, setTransactionId] = useState(null);

  const createTransaction = async (paymentData) => {
    setLoading(true);
    setError(null);
    setTransactionId(null);

    try {
      const endpoint = '/company/createTransaction';

      const body = {
        foundationId: paymentData.foundationId,
        amount: paymentData.amount,
        userId: paymentData.userId,
        paymentMethod: paymentData.paymentMethod,
        paymentType: paymentData.paymentType,
        pasarela: 'EPAYCO',
        userCity: paymentData.city,
        userAddress: paymentData.address,
        currency: paymentData.currency,
        quantity: paymentData.quantity,
        note: paymentData.note || '',
        epaycoPaymentSourceId: paymentData.selectedCreditCard || '',
        creditCardBrand: paymentData.creditCardBrand || '',
        creditCardMask: paymentData.creditCardMask || '',
        company: paymentData.company,
        ...(paymentData.campaignId && { programId: paymentData.campaignId }),
      };

      const response = await fetch(`${config.apiUrl}${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || 'Error creando la transacción');
      }
      setTransactionId(data.reference);
      return data.reference;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    createTransaction,
    loading,
    error,
    transactionId
  };
};

export default useCreateTransaction;
